/**
 * The address of an application path for a full-page navigation.
 *
 * React Router adds the base path of the build to each `navigate()` and each
 * `<Link>`. `window.location.assign()` and a sign-in `callbackUrl` do not go
 * through the router, so a bare `/desk` leaves the application when the build
 * has a base path. Staging is such a build (`VITE_BASE=/staging/dowgate/`),
 * and so is the scenario copy. This helper puts the base in front of an
 * absolute path. It does nothing to a path that has the base already, to a
 * relative path or to a full URL. With the base `/` it returns the path as it
 * is.
 */
export function appPath(path: string): string {
    const base = import.meta.env.BASE_URL.replace(/\/$/, '');
    if (!base || !path.startsWith('/') || path.startsWith('//')) return path;
    if (path === base || path.startsWith(`${base}/`) || path.startsWith(`${base}?`)) return path;
    return `${base}${path}`;
}
